import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export type TableRowNavigationActionProps = {
  id?: string;
  isOpen?: boolean;
  to: string;
  valueKey?: string;
  isClickCallbackEnabled?: boolean;
  onClick?: () => void;
  onClose?: () => void;
};

export const TableRowNavigationAction = ({
  id,
  isOpen,
  to,
  isClickCallbackEnabled,
  onClick,
  onClose,
}: TableRowNavigationActionProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    if (isClickCallbackEnabled) {
      onClick?.();
    }

    navigate(to.replace(':id', id ?? ''));

    onClose?.();
  }, [isOpen]);

  return <></>;
};

export default TableRowNavigationAction;
